<template>
  <!-- template for the modal component -->
  <transition name="modal">
    <div class="modal-mask">
      <div class="overlay" @click.prevent="$emit('close')"></div>
      <div v-if="name === 'stores'" class="overlay" @click.prevent="$root.$emit('goToStores')"></div>
      <div class="modal-wrapper">
        <div class="modal-container" :class="{'mw-500': name === 'upload'}">

          <div class="modal-header">
            <slot v-if="name !== 'stores'" name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot v-if="name === 'upload'" name="footer">
              <button class="modal-default-button cancel" @click.prevent="$emit('close')">
                Close
              </button>
              <button class="modal-default-button submit" @click.prevent="$root.$emit('submit')">
                Submit
              </button>
            </slot>
            <slot v-else-if="name === 'storesSelect'" name="footer">
              <button class="modal-default-button cancel" @click.prevent="$emit('close')">
                Close
              </button>
              <button class="modal-default-button submit" @click.prevent="$root.$emit('next')">
                Next
              </button>
            </slot>
            <slot v-else-if="name === 'stores'" name="footer">
              <button class="modal-default-button close" @click.prevent="$root.$emit('select')">
                OK
              </button>
            </slot>
            <slot v-else name="footer">
              <button class="modal-default-button close" @click.prevent="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '../eventbus.js'
export default {
  name: 'modal',
  data () {
    return {

    }
  },
  props: [
    'name'
  ],
  methods: {
    submitPromo () {
      EventBus.$root.$emit('submitFile')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    max-width: 75vw;
    width: 100%;
    margin: 0px auto;
    // padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    max-height: 75vh;
    overflow-y: auto;
    position: relative;
  }

  .upload-modal-container {
    max-width: 75vw;
    width: 25%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    max-height: 75vh;
    overflow-y: scroll;
  }

  .modal-header {
      position: sticky;
      top: 0;
      padding: 1rem 2rem 1rem;
      background: #e4e4e4;
      h3 {
        margin-top: 0;
        color: #42b983;
      }
  }

  .modal-body {
    padding: 1rem 2rem 1rem;
  }

  .modal-footer{
    position: sticky;
    // height: 55px;
    padding: 1rem 2rem 1rem;
    bottom: 0;
    right: 0;
    width: 100%;
    background-color: #fff;
    display: flex;
    vertical-align: middle;
    justify-content: flex-end;
    align-items: center;
    .close {
      background-color: #0078A3 !important;
      border-color: #0078A3 !important;
    }
  }
  .submit {
    background-color: #1CA603 !important;
    border-color: #1CA603 !important;
  }
  .cancel {
    background-color: #EE3A42 !important;
    border-color: #EE3A42 !important;
  }

  .modal-default-button {
    float: right;
    // position: absolute;
    // position: relative;
    height: 35px;
    margin: 0 5px;
    // right: 0;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/modal.vue